import { Box } from '@mui/material';
import React from 'react';
import { useWizardWithData } from '../../../../../../../../../core/hooks/WizardWithData';
import { AodRuleUpdater } from '../../../../aod-rule-edit/wizard/AodRuleEditUpdater';
import { AodRuleWizardValues } from '../../../types';
import { AodRuleCreator } from './AodRuleCreator';
import { BasicInfoReview } from './BasicInfoReview';

export function AodBaseReview({ children }: { children: React.ReactNode }) {
  const { data } = useWizardWithData<AodRuleWizardValues<any, any, any>>();

  return (
    <Box>
      <BasicInfoReview basic={data.basic} />
      {children}
      {data.rule && <AodRuleUpdater rule={data.rule} />}
      {!data.rule && <AodRuleCreator />}
    </Box>
  );
}
